<template>
	<span :class="['accountAnnouncementItem', {'today': item.today}]">
		<span class="icon" v-html="getIcon()"></span>
		<span class="subText" v-html="getSubText()"></span>
		<span class="name">{{ item.name }}</span>
		<span class="date">&#128197; {{ item.date }}</span>
	</span>
</template>

<script>

export default {
	name: "accountAnnouncementItem",
	props: {
		item: Object,
	},
	methods: {
		getIcon() {
			if (this.item.type === 3) return '🔥';
			if (this.item.type === 2) return '🤟🥳💃';
			return '&#127874; &#127873; &#127881;';
		},
		getSubText() {
			if (this.item.type === 3) return 'Anniversary';
			if (this.item.type === 2) return 'Holiday';
			return 'Birthday';
		}
	},
};
</script>

<style scoped lang="scss">
	@import "accountAnnouncementItem";
</style>
